import React from 'react'

// header & footer
import Header from "components/Header";
import Footer from "components/Footer";

export default function LayoutTheme1(props) {
    // props
    const {
        children
    } = props

    return (
        // <div className="app-root-layout overflow-auto d-flex flex-column" style={{ height: '100vh' }}>
        <div className="app-root-layout">
            {/* HEADER */}
            <Header />

            {
                /* ALL CONTENT */
                children
            }

            {/* FOOTER */}
            <Footer />
        </div>
    )
}
